/**
 * Sipariş durumları
 */
export const OrderStatus = {
  Pending: 0,
  Processing: 1,
  Shipped: 2,
  Delivered: 3,
  Canceled: 4,
  Returned: 5,
  Refunded: 6,
  BankTransferPending: 7,
  PaymentWaiting3DSecure: 8,
  PaymentCompleted: 9,
  PaymentFailed: 10
};

/**
 * Ödeme yöntemleri
 */
export const PaymentMethod = {
  CREDIT_CARD: 2,
  BANK_TRANSFER: 1,
  CASH_ON_DELIVERY: 3
};

/**
 * Ödeme yöntemi ID'lerinin PaymentMethod enum değerine eşleştirmesi
 */
export const PaymentMethodMapping = {
  'payment1': PaymentMethod.BANK_TRANSFER,
  'payment2': PaymentMethod.CASH_ON_DELIVERY,
  'payment3': PaymentMethod.CREDIT_CARD
};

/**
 * Ödeme yöntemlerinin Türkçe karşılıkları
 */
export const PaymentMethodLabels = {
  [PaymentMethod.BANK_TRANSFER]: 'Havale/EFT',
  [PaymentMethod.CASH_ON_DELIVERY]: 'Kapıda Ödeme',
  [PaymentMethod.CREDIT_CARD]: 'Kredi Kartı'
};

/**
 * Sipariş durumlarının Türkçe karşılıkları
 */
export const OrderStatusLabels = {
  [OrderStatus.Pending]: 'Bekleniyor',
  [OrderStatus.Processing]: 'Hazırlanıyor',
  [OrderStatus.Shipped]: 'Kargoya Verildi',
  [OrderStatus.Delivered]: 'Teslim Edildi',
  [OrderStatus.Canceled]: 'İptal Edildi',
  [OrderStatus.Returned]: 'İade Edildi',
  [OrderStatus.Refunded]: 'Geri Ödeme Yapıldı',
  [OrderStatus.BankTransferPending]: 'Havale Onayı Bekleniyor',
  [OrderStatus.PaymentWaiting3DSecure]: '3D Secure Ödeme Bekleniyor',
  [OrderStatus.PaymentCompleted]: 'Ödeme Alındı',
  [OrderStatus.PaymentFailed]: 'Ödeme Başarısız'
}; 